import React from "react";
import { useUserData } from "../utils/UserData";
import PostsList from "../components/PostsList";
import { usePageTitle } from "../utils/usePageTitle";

export default function PageBlog() {
    usePageTitle("Blog");
    const data = useUserData();

  return (
    <main className="max-w-6xl mx-auto px-6 py-12 text-gray-800 space-y-8">
      <h2 className="text-3xl font-semibold text-center text-slate-800">
        Blog
      </h2>

      <p className="text-base leading-relaxed text-slate-700 mx-auto">
        {data.blogPageDesc}
      </p>

      <PostsList />
    </main>
  );
}
